<template>
  <base-dialog class="details-setting-dialog" :visible.sync="visible" width="960px">
    <template #header>设置</template>
    <el-tabs v-model="activeTab" type="card">
      <el-tab-pane label="数据范围" name="range">
        <range-privilege
          v-if="sheet && visible"
          :sheet="sheet"
          :sheetPris="sheetPris"
        ></range-privilege>
      </el-tab-pane>
      <el-tab-pane label="字段权限" name="fields">
        <fields-privilege
          ref="fieldsPrivilege"
          :sheet="sheet"
          :fieldPrisMap="fieldPrisMap"
        ></fields-privilege>
      </el-tab-pane>
    </el-tabs>
    <template #footer>
      <base-button @click="visible = false">取 消</base-button>
      <base-button type="primary" @click="submit">确 定</base-button>
    </template>
  </base-dialog>
</template>

<script>
import RangePrivilege from "./range-privilege"
import FieldsPrivilege from "./fields-privilege"
import BaseDialog from "@/components/UIComponents/BaseDialog.vue"
import BaseButton from "@/components/UIComponents/Button.vue"
export default {
  name: "details-setting",
  components: {
    RangePrivilege,
    FieldsPrivilege,
    BaseDialog,
    BaseButton
  },
  data() {
    return {
      visible: false,
      sheet: null,
      fieldPrisMap: null,
      sheetPris: null,
      activeTab: "range"
    }
  },
  methods: {
    open({ sheet, fieldPrisMap, sheetPris }) {
      this.visible = true
      Object.assign(this, this._.cloneDeep({ sheet, fieldPrisMap, sheetPris }))
      this.$nextTick(() => {
        this.$refs.fieldsPrivilege.initial()
      })
    },
    submit() {
      let fieldPris = this.$refs.fieldsPrivilege.output()
      this.$emit("submit", this.sheetPris, fieldPris)
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.details-setting-dialog {
}
</style>
